<div [formGroup]="form" class="row form-wrapper">
  <div class="col-12 col-md-6">
    <app-input-form-field
      formControlName="caseTitle"
      [label]="'case.fields.caseTitle.label' | translate"
      [helpText]="'case.fields.caseTitle.help'"
      [viewMode]="viewMode"
      [isRequired]="true"
    ></app-input-form-field>
  </div>
  <div class="col-12 col-md-6">
    <app-configuration-select-form-field
      formControlName="caseType"
      [label]="'case.fields.caseType.label' | translate"
      [helpText]="'case.fields.caseType.help'"
      [isRequired]="true"
      [placeholder]="'placeholders.please_select'"
      [clearable]="true"
      [searchable]="true"
      [viewMode]="viewMode"
      [externalSearch]="true"
      [params]="{
        type: dropdownCaseType,
        entry1: form.get('caseType')?.value || ''
      }"
      [entry]="'entry1'"
    ></app-configuration-select-form-field>
  </div>
  <div class="col-12 col-md-12">
    <app-rich-text-editor
      formControlName="problemDescription"
      [label]="'case.fields.problemDescription.label' | translate"
      [helpText]="'case.fields.problemDescription.help'"
      [readonly]="viewMode"
      [isRequired]="true"
      [editableInline]="!form.disabled"
    >
    </app-rich-text-editor>
  </div>
  <div class="col-12 col-md-6" *ngIf="!viewMode">
    <app-select-form-field
      formControlName="severity"
      [users]="false"
      [label]="'case.fields.severity.label' | translate"
      [helpText]="'case.fields.severity.help'"
      [isRequired]="true"
      [placeholder]="'placeholders.please_select'"
      [clearable]="true"
      [searchable]="false"
      [bindValue]="'value'"
      [items]="severityItems"
      [viewMode]="viewMode"
    ></app-select-form-field>
  </div>
  <div class="col-12 col-md-6">
    <app-input-form-field
      formControlName="businessImpact"
      [isRequired]="true"
      [label]="'case.fields.businessImpact.label' | translate"
      [helpText]="'case.fields.businessImpact.help'"
      [viewMode]="viewMode"
    ></app-input-form-field>
  </div>
  <div class="col-12 col-md-12">
    <app-upload-attachments (attachmentsChange)="onFileUpload($event)" [isRequired]="false" [label]="'label.attachments' | translate" [readonly]="viewMode" [uploadedFiles]="uploadedFiles" [caseId]="caseId" [caseType]="caseType" [touched]="attachmentsTouched" [disabled]="form.disabled"></app-upload-attachments>
  </div>
  @if(extended) {
  <div class="col-12 col-md-6">
    <app-configuration-select-form-field
      formControlName="classification"
      [label]="'case.fields.classification.label' | translate"
      [helpText]="'case.fields.classification.help'"
      [placeholder]="'placeholders.please_select'"
      [clearable]="true"
      [searchable]="true"
      [viewMode]="viewMode"
      [externalSearch]="true"
      [params]="{
        type: dropdownClasificationType,
        entry1: form.get('classification')?.value || ''
      }"
      [entry]="'entry1'"
    ></app-configuration-select-form-field>
  </div>
  <div class="col-12 col-md-6">
    <app-input-form-field
      formControlName="errorCode"
      [label]="'case.fields.errorCode.label' | translate"
      [helpText]="'case.fields.errorCode.help'"
      [translatable]="false"
      [viewMode]="viewMode"
    ></app-input-form-field>
  </div>
  <div class="col-12 col-md-12">
    <app-rich-text-editor
      formControlName="msDynamicsReferenceNumber"
      [label]="'case.fields.msDynamicsReferenceNumber.label' | translate"
      [helpText]="'case.fields.msDynamicsReferenceNumber.help'"
      [readonly]="viewMode"
      [translatable]="false"
      [editableInline]="!form.disabled"
    >
    </app-rich-text-editor>
  </div>
  <div class="col-12 col-md-6">
    <app-datepicker-form-field
      formControlName="problemFirstOccurredDate"
      [label]="'case.fields.problemFirstOccurredDate.label' | translate"
      [helpText]="'case.fields.problemFirstOccurredDate.help'"
      [viewMode]="viewMode"
      [maxDate]="datepickerMaxDate"
    ></app-datepicker-form-field>
  </div>
  <div class="col-12 col-md-6">
    <app-input-form-field
      formControlName="relatedCase"
      [label]="'case.fields.relatedCase.label' | translate"
      [helpText]="'case.fields.relatedCase.help'"
      [translatable]="false"
      [viewMode]="viewMode"
    ></app-input-form-field>
  </div>
  <div class="col-12 col-md-3">
    <app-checkbox-form-field
      formControlName="reoccurringProblem"
      [label]="'case.fields.reoccurringProblem.label' | translate"
      [helpText]="'case.fields.reoccurringProblem.help'"
      [viewMode]="viewMode"
    ></app-checkbox-form-field>
  </div>
  <div class="col-12 col-md-3">
    <app-checkbox-form-field
      formControlName="troubleshootingAttached"
      [label]="'case.fields.troubleshootingAttached.label' | translate"
      [helpText]="'case.fields.troubleshootingAttached.help'"
      [viewMode]="viewMode"
    ></app-checkbox-form-field>
  </div>
  }

  @if(viewMode) {
    <div class="col-12 col-md-6 form-field-wrapper form-link">
      <div class="responsive-field">
        <label class="form-field-label form-field-label__overview d-inline-block text-secondary">
          <app-input-helper-text [helpText]="'case.fields.problemRecord.help'"></app-input-helper-text>
          {{ 'case.fields.problemRecord.label' | translate }}
        </label>
        @if(form.get('problemRecord')?.value) {
          <span class="field-value field-value-inline linked-value" (click)="goToProblemRecord()">
            {{ form.get('problemRecord')?.value }}
          </span>
        } @else {
          <span class="no-data-inline-form">/</span>
        }
      </div>
    </div>
  }

</div>
